module.exports = __webpack_public_path__ + "static/media/devices@4x.2b570e89.png";